export default {
  props: {
    text: String,
    type: {
      type: String,
      default: 'default',
    },
    size: String,
    icon: String,
  },
  computed: {
    buttonCss() {
      return {
        'uk-button': true,
        [`uk-button-${this.type}`]: true,
        [`uk-button-${this.size}`]: !!this.size,
      };
    },
  },
  methods: {
    focus() {
      const { button } = this.$refs;
      if (button && button.focus) {
        button.focus();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./mixins/Button.js